import { registerAuditPublisher } from '@/platform/events/AuditPublisher';
import { registerNotificationPublisher } from '@/platform/events/NotificationPublisher';

let initialized = false;
let unsubscribeHandlers: Array<() => void> = [];

export function initializePlatformEventPipeline() {
  if (initialized) {
    return;
  }

  unsubscribeHandlers = [
    registerAuditPublisher(),
    registerNotificationPublisher(),
  ];
  initialized = true;
}

export function disposePlatformEventPipeline() {
  if (!initialized) {
    return;
  }

  unsubscribeHandlers.forEach((unsubscribe) => unsubscribe());
  unsubscribeHandlers = [];
  initialized = false;
}
